import type {
  MetricAggregate,
  ViewElement,
} from "../../shared/api/generated/contracts";
import { useLocale } from "../../shared/i18n";
import { Card } from "../../shared/ui";
import {
  applyFilters,
  parseListConfig,
  recordsOfCollection,
} from "./listConfig";
import { METRIC_AGGREGATES, aggregate } from "./metric";
import type { RendererContext } from "./registry";

/** Stat tile: a label and one aggregate over the filtered records. */
export function MetricWidget({
  element,
  context,
}: {
  element: ViewElement;
  context: RendererContext;
}) {
  const { locale, t } = useLocale();
  const config = element.config;
  const requested = config?.aggregate as MetricAggregate;
  const kind = METRIC_AGGREGATES.includes(requested) ? requested : "count";
  const fieldId =
    typeof config?.field_id === "string" ? config.field_id : undefined;
  const { filters } = parseListConfig(config);
  const collectionId =
    typeof config?.collection_id === "string"
      ? config.collection_id
      : context.collectionId;
  const value = aggregate(
    applyFilters(recordsOfCollection(context.records, collectionId), filters),
    kind,
    fieldId,
  );
  const label =
    typeof config?.label === "string" ? config.label : t("widget.metric");
  return (
    <Card>
      <p className="flex flex-col gap-1">
        <span className="text-caption text-fg-muted">{label}</span>
        <strong className="text-h2 text-fg">
          {value === null
            ? "—"
            : new Intl.NumberFormat(locale, {
                maximumFractionDigits: 1,
              }).format(value)}
        </strong>
      </p>
    </Card>
  );
}
